import React from 'react';
export function Footer() {
  return <footer className="border-t border-gold/20 bg-cream py-8 mt-12" data-id="element-48">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-49">
        <p className="font-sans text-[10px] sm:text-xs text-gray-400 mb-2" data-id="element-50">
          * Resultados individuales pueden variar. La información presentada en
          este artículo tiene fines puramente educativos y no sustituye el
          consejo médico profesional.
        </p>
        <p className="font-sans text-[10px] sm:text-xs text-gray-400" data-id="element-51">
          © {new Date().getFullYear()} Belleza Natural. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}